import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType } from '@angular/common/http';

import * as Models from '../../models/brand-managament/brand-managament';
import * as SearchModels from '../../models/brand-managament/brand-managamentSearch';
import { EnvironmentService } from '../../../app/services/environment.service';
import { TyrePreviewModel } from '../../models/tyre/tyrePreview';

@Injectable({
  providedIn: 'root'
})

export class BrandManagamentService {

constructor(private httpClient: HttpClient,
            private environment: EnvironmentService
            ) {}

public getProducerDictionary() {
  const httpHeaders = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Cache-Control', 'no-cache');

  const options = {headers: httpHeaders};
  return this.httpClient.post<Models.ProducerListModel>
  (`${this.environment.getApiURL()}/brand-managament/producer/list`, options);
}


public getList(Search: SearchModels.BrandManagamentSearchModel) {
  const httpHeaders = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Cache-Control', 'no-cache');

  Search.RequestSignature = Math.random();

  const options = {headers: httpHeaders};
  return this.httpClient.post<Models.BrandManagamentListModel>
  (`${this.environment.getApiURL()}/brand-managament/list`, Search, options);
}


public deleteBrand(BrandId: number) {
  const httpHeaders = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Cache-Control', 'no-cache');

  const options = {headers: httpHeaders};
  return this.httpClient.get<HttpEventType>(`${this.environment.getApiURL()}/brand-managament/delete/brand/${BrandId}`,  options);
}

public deleteProducer(ProducerId: number) {
  const httpHeaders = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Cache-Control', 'no-cache');

  const options = {headers: httpHeaders};
  return this.httpClient.get<HttpEventType>(`${this.environment.getApiURL()}/brand-managament/delete/producer/${ProducerId}`,  options);
}


public insertProducer(NewProducer: Models.BrandManagamentModel) {
  const httpHeaders = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Cache-Control', 'no-cache');

  const options = {headers: httpHeaders};
  return this.httpClient.post<HttpEventType>(
    `${this.environment.getApiURL()}/brand-managament/insert/producer`, NewProducer , options);
}


public insertBrand(NewBrand: Models.BrandManagamentModel) {
  const httpHeaders = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Cache-Control', 'no-cache');

  const options = {headers: httpHeaders};
  return this.httpClient.post<HttpEventType>(
    `${this.environment.getApiURL()}/brand-managament/insert/brand`, NewBrand , options);
}


public setProducer(Producer: Models.BrandManagamentModel) {
  const httpHeaders = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Cache-Control', 'no-cache');

  const options = {headers: httpHeaders};
  return this.httpClient.post<HttpEventType>(
    `${this.environment.getApiURL()}/brand-managament/set/producer`, Producer , options);
}


public setBrand(Brand: Models.BrandManagamentModel) {
  const httpHeaders = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Cache-Control', 'no-cache');

  const options = {headers: httpHeaders};
  return this.httpClient.post<HttpEventType>(
    `${this.environment.getApiURL()}/brand-managament/set/brand`, Brand , options);
}


}
